import { useData } from 'components/common-form/hooks/useData';
import { useFieldMetadata } from 'components/common-form/hooks/useFieldMetadata';
import { useFieldTranslationKey } from 'components/common-form/hooks/useFieldTranslationKey';
import { BlockOrientationFormGroup } from 'components/shared/FormGroup';
import { LabelWithTooltip } from 'components/shared/LabelWithTooltip/LabelWithTooltip';
import type { DateLabelFieldData, DateLabelFieldMetadata } from 'models/forms/fields';
import { FC } from 'react';

import type { ProductNodeBuilderProps } from '../ProductNodeBuilder.model';

export const DateLabelField: FC<ProductNodeBuilderProps> = ({ node: { id } }) => {
  const [value] = useData<DateLabelFieldData>(id);
  const translationKey = useFieldTranslationKey(id);
  const metadata = useFieldMetadata<DateLabelFieldMetadata>(id);

  const date = value !== null ? getDefaultDateFormat(new Date(Date.parse(value))) : '';

  return (
    <BlockOrientationFormGroup
      inputId={id}
      label={`form.${translationKey}` as any}
      minWidth={metadata?.minWidth}
      maxWidth={metadata?.maxWidth}
    >
      <LabelWithTooltip label={date || ''} tooltip={date || ''} className="text-start" />
    </BlockOrientationFormGroup>
  );
};

function getDefaultDateFormat(date: Date) {
  return date.toLocaleDateString('en-us', { day: 'numeric', month: 'short', year: 'numeric' });
}

DateLabelField.displayName = 'DateLabelField';
